import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-almost-loaded',
  templateUrl: './almost-loaded.component.html',
  styleUrls: ['./almost-loaded.component.scss']
})
export class AlmostLoadedComponent implements OnInit {
    @Input() spinnerSize = 45;

    constructor() { }

    ngOnInit(): void {
    }

}
